var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy"},[_c('div',{attrs:{"name":"termly-embed","data-id":"a80a6f41-fd03-4469-b589-5bd790e52d6f","data-type":"iframe"}})])
}]

export { render, staticRenderFns }